import { list as getList, listMetrics } from "~/api/contractDatabase";
import * as types from "../mutation-types";
import store from "../../store";
import { entityStoreStatus } from "~/mixins/entityStoreStatus";
import { clearableStore } from '~/mixins/clearableStore';
/**
 * Initial state
 */
export const state = {
  list: null,
  metrics: null,
  isLoading: false,
  isInitialLoadPending: true,
};

/**
 * Mutations
 */
export const mutations = {
  ...clearableStore.mutations,
  [types.SET_IS_LOADING_CONTRACT_DATABASE](state, status) {
    state.isLoading = status;
  },
  [types.SET_CONTRACT_DATABASE](state, contractDatabase) {
    state.list = contractDatabase.data;
    state.isInitialLoadPending = false;
  },
  [types.SET_DATABASES_METRIC](state, data) {
    const incoming = Array.isArray(data?.data) ? data.data : [];

    if (!state.metrics || !Array.isArray(state.metrics)) {
      state.metrics = incoming;
      return;
    }

    const byName = {};

    state.metrics.forEach((m) => {
      if (m && m.name && !(m.name in byName)) {
        byName[m.name] = m;
      }
    });

    incoming.forEach((m) => {
      if (m && m.name) {
        byName[m.name] = m;
      }
    });

    state.metrics = Object.values(byName);
  }
};

/**
 * Actions
 */
export const actions = {
  fetchContractDatabases({ commit }, contractId = null) {
    commit(types.SET_IS_LOADING_CONTRACT_DATABASE, true);
    let activeContractId =
      contractId || store.getters["contract/activeContract"]?.id;

    if (activeContractId) {
      getList(activeContractId).then((response) => {
        let { data } = response;
        commit(types.SET_CONTRACT_DATABASE, data);
        commit(types.SET_IS_LOADING_CONTRACT_DATABASE, false);
      });
    }
  },
  async fetchDatabasesMetrics({ commit }, contractId = null) {
    try {
      await listMetrics(contractId).then(({ data }) => {
        commit(types.SET_DATABASES_METRIC, data);
      });
    } catch (e) {
      // commit(types.FETCH_USER_FAILURE);
    }
  },


};

/**
 * Getters
 */
export const getters = {
  list: (state) => state.list,
  isLoading: (state) => state.isLoading,
  isInitialLoadPending: (state) => state.isInitialLoadPending,
  metrics: (state) => state.metrics,
  getMetric: (state) => (name) => {
    const metric = state.metrics?.find(b => b.name === name);
    return metric;
  },
  ...entityStoreStatus.getters
};
